import { useMutation, useQueryClient } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface ReprocessRunResponse {
  runId: string;
}

export const useReprocessRun = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (runId: string): Promise<ReprocessRunResponse> => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.POST });
      const response = await fetch(`${APIBaseChronos}/api/run/${runId}/reprocess`, fetchConfig);
      if (!response.ok) {
        const errorData = (await response.json().catch(() => ({}))) as { message?: string };
        throw new Error(errorData.message ?? 'Failed to enqueue reprocessing run');
      }
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.Runs, { matterId }]);
      },
    },
  );
};
